import { simpleSet } from '@r/reducers/utils';

const sForOpen = simpleSet as redux.reducers.modals.cornerMenuVisible;

export const cornerMenuVisible = sForOpen( 'SET_CORNER_MENU_VISIBLE', true );
